module.exports = __webpack_public_path__ + "static/media/heart_icon_black.d3e2002c.svg";